import React from 'react'
import classNames from 'classnames'
import './Loader.scss'

interface Props {
    align?: 'middle'
}

export default class Loader extends React.Component<Props> {

    public render() {

        const loaderClasses = classNames({
            'loader': true,
            'loader--middle': this.props.align === 'middle'
        })

        return (
            <div className={loaderClasses} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Loader/index.tsx